module.exports = __webpack_public_path__ + "img/ej-logo.00278341.svg";